import dayjs from "dayjs";

import { FotoUser } from "../../../../../../../assets";
import { ProfileActivityTag } from "../../../../../../../components";
import { ActivityDTO } from "../../types/activityDTO";
import { minutesToStringHoursAndMinutes } from "../../utils";
import * as s from "./styles";

type TCollaboratorsHours = {
    activity: ActivityDTO;
};

export const CollaboratorsHours = ({ activity }: TCollaboratorsHours) => {
    return (
        <s.Container>
            <s.Title>Horas realizadas por profissional</s.Title>
            <s.Content>
                {activity.historic_hour_collaborators.map((collaborator) => (
                    <s.Row key={collaborator.user_id}>
                        <s.Picture src={collaborator.avatar ?? FotoUser} />
                        <s.Wrapper>
                            <div>
                                <s.Name>{collaborator.name}</s.Name>
                                <s.LastUpdate>
                                    última atualização em{" "}
                                    {dayjs(collaborator.last_update).format(
                                        "DD/MM/YYYY"
                                    )}
                                </s.LastUpdate>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.75rem",
                                    flexWrap: "wrap",
                                }}
                            >
                                {collaborator?.profiles &&
                                    collaborator?.profiles?.length > 0 &&
                                    collaborator.profiles.map((profile) => (
                                        <ProfileActivityTag
                                            key={profile.id_e}
                                            abbreviation={profile.abbreviation}
                                            name={profile.name}
                                        />
                                    ))}
                            </div>
                            <s.HoursDone>
                                {minutesToStringHoursAndMinutes(
                                    collaborator.total_time
                                )}
                            </s.HoursDone>
                        </s.Wrapper>
                    </s.Row>
                ))}
            </s.Content>
        </s.Container>
    );
};
